<div class="c-contenedor position-relative" >
    <div class="row">
        <div class="col-12 p-0">
            <img class="icon-close pr-10" (click)="onCloseClick()" src="assets/icons/ico-close.png" alt="cerrar">
        </div>
    </div>
    <div class="row justify-content-center">
        <ng-container *ngIf="data.icon" class="icon-general">
            <img class="icon-general" src="{{ data.icon }}" alt="icon">
        </ng-container>
        <div class="col-12">
            <h1 mat-dialog-title class="not-ng-deep c-titulo-dialogo"> {{ data.title }} </h1>

            <mat-dialog-content class=" not-ng-deep c-titulo-subtitulo" [innerHTML]="data.description"> </mat-dialog-content>

            <mat-dialog-actions>
                <button (click)="onActionClick()" class="btn-primary-tbk mx-auto dis btn-action">{{ data.actionButton }}</button>
            </mat-dialog-actions>
        </div>
        <div></div>
    </div>
    <div class="code position-absolute bottom-0"*ngIf="data.errorCode" >{{data.errorCode}}</div>
</div>